import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Lib from '../../../commons/lib';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';

class RaktarLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'LOAD',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // FORM VALUES
      formAzonosito: '',
      formMegnevezes: '',
      formCegadat: '',
      formStatusz: '',
      // UTILS
      // errorFromServer: '-',
      // idFromForm: null,
      // idFromServer: null,
      currentId: null,
      baseJson: [],
      uzletOptions: [],
      modalState: false,
      modalTorles: false,
      // modalValtozas: false,
      torlesId: null,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
    };
  }

  componentDidMount() {
    this.getRaktarList();
  }

  toggleModal = () => {
    this.setState(prevState => ({ modalState: !prevState.modalState }));
  }

  toggleTorles = () => {
    this.setState(prevState => ({ modalTorles: !prevState.modalTorles }));
  }

  // toggleValtozas = () => {
  //   this.setState(prevState => ({ modalValtozas: !prevState.modalValtozas }));
  // }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  getCegadatOptions = (id) => {
    Services.listAktivCegadat(id, (err, res) => {
      if (!err) {
        let resOptions = res[0].map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.tipus + ')'}</option>);
        this.setState({ uzletOptions: resOptions });
      }
    });
  }

  deleteRaktar = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteRaktar(this.state.torlesId, (err) => {
      if (!err) {
        this.setState({
          deleteButtonLoading: false
        });
        this.toggleTorles();
        this.getRaktarList();
        this.props.globals.addSuccess('Raktár törölve!');
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  getRaktarList = () => {
    this.setState({
      tableStatus: 'LOAD'
    });
    Services.getRaktarList((err, res) => {
      if (!err) {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });
        this.setState({
          tableStatus: 'TABL',
          baseJson: res[0].list,
          statusz: res[0].statusz,
          statuszOptions: options,
          filterOptions: filters,
        });
      } else {
        this.setState({
          tableStatus: 'NETW'
        });
      }
    });
  }

  getRaktar = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Promise.all([
      this.getRaktarService(id),
    ])
      .then(() => {
        this.setState({
          formStatus: 'DATA'
        });
      })
      .catch(() => {
        this.setState({
          formStatus: 'NETW'
        });
      });
  }

  getRaktarService = (id) => {
    return new Promise((resolve, reject) => {
      Services.getRaktar(id, (err, res) => {
        if (!err) {
          this.setState({
            formCegadat: this.nullToString(res[0].cegadatid),
            formAzonosito: this.nullToString(res[0].azonosito),
            formMegnevezes: this.nullToString(res[0].nev),
            formStatusz: this.nullToString(res[0].statusz.name),
          }, () => {
            this.getCegadatService(res[0].cegadatid, resolve);
          });
        } else {
          reject(new Error('Hálozati hiba!'));
        }
      });
    });
  }

  getCegadatService = (id, resolve) => {
    Services.listAktivCegadat(id, (err, res) => {
      if (!err) {
        let resOptions = res[0].map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.tipus + ')'}</option>);
        this.setState({ uzletOptions: resOptions }, () => {
          resolve(id);
        });
      }
    });
  };

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  handleSubmit = () => {
    const {
      formAzonosito,
      formMegnevezes,
      formStatusz,
      formCegadat,
      formType,
      currentId
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {
        azonosito: this.emptyOrNull(formAzonosito),
        nev: this.emptyOrNull(formMegnevezes),
        cegadatid: this.emptyOrNull(formCegadat),
        statusz: this.emptyOrNull(formStatusz)
      };

      Services.addRaktar(submitObj, (err) => {
        if (!err) {
          this.toggleModal();
          this.getRaktarList();
          this.props.globals.addSuccess('Raktár felvéve!');
          this.setState({
            saveButtonLoading: false
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }

    if (formType === 'MOD') {
      let submitObj = {
        id: this.emptyOrNull(currentId),
        azonosito: this.emptyOrNull(formAzonosito),
        nev: this.emptyOrNull(formMegnevezes),
        cegadatid: this.emptyOrNull(formCegadat),
        statusz: this.emptyOrNull(formStatusz)
      };

      // Services.existsNew(formCegadat, (err, res) => {
      //   if (!err) {
      //     this.setState({
      //       saveButtonLoading: false
      //     });
      //     if (res[0].hiba === null) {
            Services.editRaktar(submitObj, (err2) => {
              if (!err2) {
                this.toggleModal();
                this.getRaktarList();
                this.props.globals.addSuccess('Raktár módosítva!');
                this.setState({
                  saveButtonLoading: false
                });
              } else {
                this.setState({
                  saveButtonLoading: false
                });
              }
            });
      //     } else {
      //       this.setState({ errorFromServer: res[0].hiba, idFromServer: res[0].id, idFromForm: formCegadat, submitObj: submitObj }, () => {
      //         this.toggleValtozas();
      //       });
      //     }
      //   } else {
      //     this.setState({
      //       saveButtonLoading: false
      //     });
      //   }
      // });
    }
  }

  editRaktar = (id) => {
    let submitObj = JSON.parse(JSON.stringify(this.state.submitObj));
    submitObj.cegadatid = id;
    Services.editRaktar(submitObj, (err) => {
      if (!err) {
        // this.setState({ modalValtozas: false }, () => {
          this.setState({ modalState: false }, () => {
            this.getRaktarList();
            this.props.globals.addSuccess('Raktár módosítva!');
          });
        // });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleNewClick = () => {
    this.getCegadatOptions(null);
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formAzonosito: '',
      formMegnevezes: '',
      formCegadat: '',
      formStatusz: 'AKTIV',
    }, () => {
      this.toggleModal();
    });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      formStatus: 'LOAD',
      currentId: cell,
      formAzonosito: '',
      formMegnevezes: '',
      formCegadat: '',
      formStatusz: '',
    }, () => {
      this.getRaktar(cell);
      this.toggleModal();
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleTorles();
    });
  }

  tableIconFormatter = (cell) => {
    return (
      <div>
        {
          this.props.globals.hasRole(['RAKTAR_RAKTAR'], true) && 
          (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={40}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={40}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )
      }
      </div>
    );
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új raktár létrehozása';
      case 'MOD':
        return 'Raktár módosítása';
      default:
        return '';
    }
  }

  renderForm = () => {
    const {
      formAzonosito,
      formMegnevezes,
      formCegadat,
      formStatusz,
      formType,
      uzletOptions
    } = this.state;

    return (
      <React.Fragment>
        <RFField
          label="Azonosító: *"
          name="formAzonosito"
          disabled={formType === 'MOD'}
          required
          maxLength="10"
          value={formAzonosito}
          onChange={this.handleInputChange}
        />
        <RFField
          label="Megnevezés: *"
          name="formMegnevezes"
          required
          maxLength="50"
          value={formMegnevezes}
          onChange={this.handleInputChange}
        />
        <RFField
          type="select"
          name="formCegadat"
          label="Cégadat: *"
          required
          value={formCegadat}
          onChange={this.handleInputChange}
          defaultSelect={<option value="">Válassz cégadatot...</option>}
          selectOptions={uzletOptions}
        />
        <RFField
          type="select"
          name="formStatusz"
          label="Státusz: *"
          required
          value={formStatusz}
          onChange={this.handleInputChange}
          defaultSelect={<option value="">Válassz státuszt...</option>}
          selectOptions={this.state.statuszOptions}
        />
      </React.Fragment>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Megnevezés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'cegnev',
        text: 'Cégadat neve',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'cegtipus',
        text: 'Cégadat típus',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'statusz',
        align: 'center',
        text: 'Státusz',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.props.globals.hasRole(['RAKTAR_RAKTAR'], true),
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {
              this.props.globals.hasRole(['RAKTAR_RAKTAR'], true) && 
              (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új raktár'}
              </Button>
            )}
          </div>
          <div className="col-md-12">
            {{
              LOAD: (<Loader />),
              DATA: (<DataEmptyState
                hasImage
                subtitle="Vigyél fel új tételt!"
              />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getRaktarList()}
              />),
              TABL: (this.renderTable())
            }[this.state.tableStatus]}
          </div>
        </div>
        <Modal isOpen={this.state.modalState} toggle={this.toggleModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.handleSubmit}
            title={this.renderFormTitle()}
            footer={
              <>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.saveButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleModal}>Mégsem</Button>
              </>
            }
          >
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getRaktar(this.state.currentId)}
              />),
              DATA: (this.renderForm())
            }[this.state.formStatus]}
            {/* <Modal isOpen={this.state.modalValtozas} toggle={this.toggleValtozas} className={this.props.className} backdrop="static">
              <ModalHeader>Cégadat módosult</ModalHeader>
              <ModalBody style={{ whiteSpace: 'pre-wrap' }}>
                {this.state.errorFromServer}
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  className="btn-cursor-pointer"
                  color="primary"
                  onClick={() => {
                    this.editRaktar(this.state.idFromServer);
                  }}
                >
                  Igen
                </Button>
                <Button type="button" className="btn-cursor-pointer" color="secondary" onClick={() => this.editRaktar(this.state.idFromForm)}>Nem</Button>
                <Button type="button" className="btn-cursor-pointer" color="secondary" onClick={() => this.toggleValtozas()}>Mégsem</Button>
              </ModalFooter>
            </Modal> */}
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} color="primary" onClick={() => this.deleteRaktar()}>Igen</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

RaktarLista.propTypes = {
  globals: PropTypes.object,
  className: PropTypes.string,
};

export default RaktarLista;
